import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

function SubmitReview() {
  const { ticketNumber } = useParams();
  const [formData, setFormData] = useState({
    driverExperience: '',
    overallExperience: '',
    comments: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Simulating form submission
    alert('Thank you for your feedback!');
    // Reset form
    setFormData({
      driverExperience: '',
      overallExperience: '',
      comments: ''
    });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  return (
    <>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>Submit a Review</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="page-section-ptb gray-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-title text-center mb-4">
                <h4 className="title">We'd like to hear your thoughts</h4>
                <div className="separator justify-content-center"></div>
                <p>Please fill the form below to share your experience with us.</p>
              </div>
              <form id="reviewForm" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="ticketNumber" className="form-label">Plate or Ticket Number</label>
                  <input 
                    type="text" 
                    id="ticketNumber" 
                    className="form-control" 
                    value={ticketNumber || 'PKT-189233'} 
                    disabled
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="driverExperience" className="form-label">Interaction with Driver</label>
                  <select 
                    className="form-control" 
                    id="driverExperience" 
                    value={formData.driverExperience}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select --</option>
                    <option value="Excellent">Excellent</option>
                    <option value="Good">Good</option>
                    <option value="Average">Average</option>
                    <option value="Poor">Poor</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="overallExperience" className="form-label">Overall Experience</label>
                  <select 
                    className="form-control" 
                    id="overallExperience" 
                    value={formData.overallExperience}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select --</option>
                    <option value="Excellent">Excellent</option>
                    <option value="Good">Good</option>
                    <option value="Average">Average</option>
                    <option value="Poor">Poor</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="comments" className="form-label">Comments or Complaints</label>
                  <textarea 
                    className="form-control" 
                    id="comments" 
                    rows="4" 
                    placeholder="Write here..."
                    value={formData.comments}
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div className="text-center">
                  <button type="submit" className="button red">Submit Review</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SubmitReview;
